import { render, staticRenderFns } from "./MyHandlingList.vue?vue&type=template&id=131885ba&scoped=true&"
import script from "./MyHandlingList.vue?vue&type=script&lang=js&"
export * from "./MyHandlingList.vue?vue&type=script&lang=js&"
import style0 from "./MyHandlingList.vue?vue&type=style&index=0&id=131885ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131885ba",
  null
  
)

export default component.exports